import { app } from '../../bootstrap/core';
import { AccountIdValidationService } from './accountIdValidation.service';

app.service('accountIdValidationService', AccountIdValidationService);



// WEBPACK FOOTER //
// ./src/app/common/domain/accountValidation.js